import React from 'react';

export type EmailDisplayProps = {
    children: React.ReactNode
}

const EmailDisplay = ({ children }: Readonly<EmailDisplayProps>) => (
    <div className="card">
        <div className="card-body">
            {children}
        </div>
    </div>
);

export default EmailDisplay;